module["exports"] = [
  "Ade",
  "Agnes",
  "Ajeng",
  "Amalia",
  "Anita",
  "Ayu",
  "Aisyah",
  "Ana",
  "Ami",
  "Ani",
  "Azalea",
  "Aurora",
  "Alika",
  "Anastasia",
  "Amelia",
  "Almira",
  "Bella",
  "Betania",
  "Belinda",
  "Citra",
  "Cindy",
  "Chelsea",
  "Clara",
  "Cornelia",
  "Cinta",
  "Cinthia",
  "Ciaobella",
  "Cici",
  "Carla",
  "Calista",
  "Devi",
  "Dewi","Dian",
  "Diah",
  "Diana",
  "Dina",
  "Dinda",
  "Dalima",
  "Eka",
  "Eva",
  "Endah",
  "Elisa",
  "Eli",
  "Ella",
  "Ellis",
  "Elma",
  "Elvina",
  "Fitria",
  "Fitriani",
  "Febi",
  "Faizah",
  "Farah",
  "Farhunnisa",
  "Fathonah",
  "Gabriella",
  "Gasti",
  "Gawati",
  "Genta",
  "Ghaliyati",
  "Gina",
  "Gilda",
  "Halima",
  "Hesti",
  "Hilda",
  "Hafshah",
  "Hamima",
  "Hana",
  "Hani",
  "Hasna",
  "Humaira",
  "Ika",
  "Indah",
  "Intan",
  "Irma",
  "Icha",
  "Ida",
  "Ifa",
  "Ilsa",
  "Ina",
  "Ira",
  "Iriana",
  "Jamalia",
  "Janet",
  "Jane",
  "Julia",
  "Juli",
  "Jessica",
  "Jasmin",
  "Jelita",
  "Kamaria",
  "Kamila",
  "Kani",
  "Karen",
  "Karimah",
  "Kartika",
  "Kasiyah",
  "Keisha",
  "Kezia",
  "Kiandra",
  "Kayla",
  "Kania",
  "Lala",
  "Lalita",
  "Latika",
  "Laila",
  "Laras",
  "Lidya",
  "Lili",
  "Lintang",
  "Maria",
  "Mala",
  "Maya",
  "Maida",
  "Maimunah",
  "Melinda",
  "Mila",
  "Mutia",
  "Michelle",
  "Malika",
  "Nadia",
  "Nadine",
  "Nabila",
  "Natalia",
  "Novi",
  "Nova",
  "Nurul",
  "Nilam",
  "Najwa",
  "Olivia",
  "Ophelia",
  "Oni",
  "Oliva",
  "Padma",
  "Putri",
  "Paramita",
  "Paris",
  "Patricia",
  "Paulin",
  "Puput",
  "Puji",
  "Pia",
  "Puspa",
  "Puti",
  "Putri",
  "Padmi",
  "Qori",
  "Queen",
  "Ratih",
  "Ratna",
  "Restu",
  "Rini",
  "Rika",
  "Rina",
  "Rahayu",
  "Rahmi",
  "Rachel",
  "Rahmi",
  "Raisa",
  "Raina",
  "Sarah",
  "Sari",
  "Siti",
  "Siska",
  "Suci",
  "Syahrini",
  "Septi",
  "Sadina",
  "Safina",
  "Sakura",
  "Salimah",
  "Salwa",
  "Salsabila",
  "Samiah",
  "Shania",
  "Sabrina",
  "Silvia",
  "Shakila",
  "Talia",
  "Tami",
  "Tira",
  "Tiara",
  "Titin",
  "Tania",
  "Tina",
  "Tantri",
  "Tari",
  "Titi",
  "Uchita",
  "Unjani",
  "Ulya",
  "Uli",
  "Ulva",
  "Umi",
  "Usyi",
  "Vanya",
  "Vanesa",
  "Vivi",
  "Vera",
  "Vicky",
  "Victoria",
  "Violet",
  "Winda",
  "Widya",
  "Wulan",
  "Wirda",
  "Wani",
  "Yani",
  "Yessi",
  "Yulia",
  "Yuliana",
  "Yuni",
  "Yunita",
  "Yance",
  "Zahra",
  "Zalindra",
  "Zaenab",
  "Zulfa",
  "Zizi",
  "Zulaikha",
  "Zamira",
  "Zelda",
  "Zelaya"
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/name/female_first_name.js
// module id = 1273
// module chunks = 0